export const ContentBackendSymbol = Symbol.for("ContentBackendSymbol");
